import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePlayerAuth } from "@/context/PlayerAuthContext";

/**
 * After token auth, API may return `course_id` — send user to that course from home `/`.
 * Skips when embedded lesson (LP_LESSON) is active on `/`.
 */
export function PostAuthCourseRedirect() {
  const { status, isAuthenticated, courseIdFromAuth } = usePlayerAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const didRedirect = useRef(false);

  useEffect(() => {
    const embed =
      typeof window !== "undefined" && (window.LP_LESSON?.slides?.length ?? 0) > 0;
    if (embed) return;
    if (status === "loading" || !isAuthenticated || !courseIdFromAuth) return;
    if (didRedirect.current) return;
    const path = location.pathname.replace(/\/$/, "") || "/";
    if (path !== "" && path !== "/") return;

    didRedirect.current = true;
    navigate(`/course/${courseIdFromAuth}`, { replace: true });
  }, [status, isAuthenticated, courseIdFromAuth, location.pathname, navigate]);

  return null;
}
